import * as React from "react";

interface ClockType {
  className: string;
}

export default function Clock({ className }: ClockType) {
  return (
    <div className={className}>
      <img src="/assets/clock.svg" alt="clock" />
    </div>
  );
}
